import instance from '@/api/base';

export async function GetNotConfirmedPayments() {
  const rsp = await instance.get('/v1/monthly_payments');
  return rsp.data;
}

export async function GetConfirmedPayments() {
  const rsp = await instance.get('/v1/monthly_payments?confirmed=1');
  return rsp.data;
}

// 所有薪資單（含 confirm_status），用於薪資歷史列出已確認與標記錯誤的月份
export async function GetPayslips() {
  const rsp = await instance.get('/v1/payslips');
  return rsp.data;
}

export async function GetNotNotifyPayments() {
  const rsp = await instance.get('/v1/monthly_payments?not-notify=1');
  return rsp.data;
}

export async function getMonthlyAccounting(year, month) {
  const rsp = await instance.get(`/v1/monthly_accounting/${year}/${month}`);
  return rsp.data;
}

export async function sendMonthlyAccountingResult(year, month, appointments, activities) {
  const rsp = await instance.put(`/v1/monthly_accounting/${year}/${month}`, {
    appointments,
    activities,
  });
  return rsp.data;
}

export async function getAccountingAppointments(params) {
  const rsp = await instance.get('/v1/accounting/appointments', { params });
  return rsp.data;
}

export async function setAccountingAppointmentStatus(id, confirmStatus) {
  const rsp = await instance.put(`/v1/accounting/appointment/${id}`, {
    confirm_status: confirmStatus ? 'confirmed' : 'wrong_amount',
  });
  return rsp.data;
}

export async function getMonthlyPayment(year, month) {
  const rsp = await instance.get(`/v1/monthly_payments/${year}/${month}`);
  return rsp.data;
}

export async function getMonthlyPaymentDetail(year, month) {
  const rsp = await instance.get(`/v1/monthly_payments/${year}/${month}/detail`);
  return rsp.data;
}

export async function setMonthPaymentStatus(year, month, status) {
  const rsp = await instance.put(`/v1/monthly_payments/${year}/${month}`, {
    confirm_status: status,
  });
  return rsp.data;
}

// 取得「現在」的年月（台灣時區）。以 API 回應的 HTTP Date 標頭（伺服器時間）為準，
// 避免裝置時間錯誤時月份清單偏移；取不到伺服器時間時才退回裝置時間
export async function getCurrentYearMonth() {
  let ts = NaN;
  try {
    const rsp = await instance.get('/v1/profile');
    ts = Date.parse(rsp.headers?.date);
  } catch (e) {
    ts = NaN;
  }
  if (Number.isNaN(ts)) {
    ts = Date.now();
  }
  const taipei = new Date(ts + 8 * 60 * 60 * 1000);
  return {
    year: taipei.getUTCFullYear(),
    month: taipei.getUTCMonth() + 1,
  };
}
